import React, { useEffect, useRef } from 'react';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

interface ToastMarkdownViewerProps {
  markdown: string;
}

const ToastMarkdownViewer: React.FC<ToastMarkdownViewerProps> = ({
  markdown,
}) => {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const viewerRef = useRef<Viewer | null>(null);
  const renderedMarkdownRef = useRef(markdown);

  useEffect(() => {
    if (!rootRef.current) return () => {};

    viewerRef.current = new Viewer({
      el: rootRef.current,
      initialValue: markdown,
      usageStatistics: false,
    });

    return () => {
      viewerRef.current?.destroy();
      viewerRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only: the viewer is created once and later markdown changes go through setMarkdown below
  }, []);

  useEffect(() => {
    if (markdown === renderedMarkdownRef.current) return;
    renderedMarkdownRef.current = markdown;
    viewerRef.current?.setMarkdown(markdown);
  }, [markdown]);

  return <div ref={rootRef} />;
};

export default ToastMarkdownViewer;
